import React from 'react';
import { usePageSplitClasses } from '../hooks';
export const PageSplitDivider = ({ className: optionalClassName, splitType, onMouseDown, onTouchStart, onMouseUp, }) => {
    const { dividerHitBox, divider } = usePageSplitClasses(optionalClassName, splitType);
    return (React.createElement("div", { "data-testid": "PageSplitDivider", className: dividerHitBox, onMouseDown: onMouseDown, onTouchStart: onTouchStart, onTouchEnd: onMouseUp, tabIndex: -1, role: "slider", "aria-label": "page-slider", "aria-valuenow": -1 },
        React.createElement("div", { className: divider })));
};
//# sourceMappingURL=PageSplitDivider.js.map